module.exports = __webpack_public_path__ + "f28ba05ec9583f7d2a6c5bd49384905f.png";